import React from 'react'
import { Column } from '@morningtrain/react-columns'
import { useCollection } from '@morningtrain/react-resources'
import { observer } from 'mobx-react'

function Aggregate ({ name, using = null, ...forwardProps }) {
  const collection = useCollection()

  const defaultAggregator = (acc, entry) => {
    return acc + (entry[name] || 0)
  }

  const value = collection.reduce(using || defaultAggregator, 0)

  return (
    <Column {...forwardProps} defaultValue={value} />
  )
}

export default observer(Aggregate)
